import { observer } from "mobx-react";
import "./rma-list-statuses-filters-tabs.scss";
import rmaPagedListStore, {RMA_QUICK_FILTERS} from "../../stores/rma-paged-list-store";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaStatusFilterButton from "./rma-status-filter-button";
import RmaListFiltersStore from "../../stores/rma-list-filters-store";
import currentPortalStore from "../../../../../stores/current-portal-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";


interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled: boolean;
    onFilterChange: () => void;
}

const RmaListStatusesFiltersTabs: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled, onFilterChange }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-returns-page';

    const RMA_STATUSES_CONTENT_MAP = [
        { id: RMA_QUICK_FILTERS.ALL, title: getTranslation('ALL', scope) },
        { id: RMA_QUICK_FILTERS.OPEN, title: getTranslation('OPEN', scope) },
        { id: RMA_QUICK_FILTERS.PENDING, title: getTranslation('PENDING', scope) },
        { id: RMA_QUICK_FILTERS.APPROVED, title: getTranslation('APPROVED', scope) },
        { id: RMA_QUICK_FILTERS.IN_TRANSIT, title: getTranslation('IN_TRANSIT', scope) },
        { id: RMA_QUICK_FILTERS.RECEIVED, title: getTranslation('RECEIVED', scope) },
        { id: RMA_QUICK_FILTERS.DONE, title: getTranslation('DONE', scope) },
        { id: RMA_QUICK_FILTERS.REJECTED, title: getTranslation('REJECTED', scope) },
        { id: RMA_QUICK_FILTERS.CANCELED, title: getTranslation('CANCELED', scope) },
        { id: RMA_QUICK_FILTERS.SHIPMENT_REJECTED, title: getTranslation('SHIPMENT_REJECTED', scope) },
        { id: RMA_QUICK_FILTERS.REQUIRE_ATTENTION, title: getTranslation('REQUIRE_ATTENTION', scope) },
    ];

    if(currentPortalStore.requireManagerApproval()) {
        RMA_STATUSES_CONTENT_MAP.splice(3, 0,
            {id: RMA_QUICK_FILTERS.PENDING_APPROVAL_ONLY, title:  getTranslation('PENDING_APPROVAL_ONLY', scope)}
        );
        RMA_STATUSES_CONTENT_MAP.splice(4, 0,
            {id: RMA_QUICK_FILTERS.PENDING_MANAGER_APPROVAL_ONLY, title:  getTranslation('PENDING_MANAGER_APPROVAL_ONLY', scope)}
        );
    }

    const onStatusSelect = (status: RMA_QUICK_FILTERS) => {
        rmsMixpanelStore.trackEvent(`d&_filter_${status}`, []);
        rmaListFiltersStore.setSelectedQuickFilter(status);
        rmaPagedListStore.loadPage(1);
        onFilterChange();
    }

    return (
        <div className="rma-list-statuses-filters-tabs">
            {RMA_STATUSES_CONTENT_MAP.map(status => (
                <RmaStatusFilterButton
                    key={status.id}
                    title={status.title}
                    disabled={disabled}
                    isSelected={rmaListFiltersStore.selectedQuickFilter === status.id}
                    onClick={() => onStatusSelect(status.id)}
                />
            ))}
        </div>
    )
});

export default RmaListStatusesFiltersTabs;
